import lodashGet from "lodash/get";

import { httpGet } from "@/services/api.service";
import { ENDPOINT_CYBER } from "@/common/constants/api";

export { _getCyberInfo as getCyberInfo };

const _getCyberInfo = async (params) => {
  try {
    if (!params.id) {
      console.warn("Issue getting cyber info in cyber.service.js. No id set.");
      return false;
    }

    const endpoint = `${ENDPOINT_CYBER}/${params.id}`;

    const RESULT = await httpGet({ url: encodeURI(endpoint) });
    const { data } = JSON.parse(RESULT);

    if (lodashGet(data, "features[0]")) {
      return data.features[0];
    }

    console.error(
      "Issue getting cyber info in cyber.service.js. No data.result found."
    );
    return null;
  } catch (error) {
    console.error(
      "Issue getting cyber info in cyber.service.js",
      JSON.stringify(error)
    );
    return null;
  }
};
